import React from 'react';

// Import images from assets folder
import tshirtImage from '../assets/2.png';
import hoodieImage from '../assets/3.png';
import mugImage from '../assets/5.png';
import totebagImage from '../assets/totebag3.png';
import badgecardsImage from '../assets/badgecard3.png';

const Merch = () => {
  const products = [
    { 
      id: 1, 
      name: 'ClinAddis T-Shirt', 
      price: '450 ETB', 
      desc: 'Official logo tee - 100% cotton',
      image: tshirtImage,
      imageStyle: { width: 'auto', height: 'auto', maxWidth: '500%', maxHeight: '280%', objectFit: 'contain' }
    },
    { 
      id: 2, 
      name: 'Art & Medicine Hoodie', 
      price: '850 ETB', 
      desc: 'Limited edition hoodie',
      image: hoodieImage,
      imageStyle: { width: 'auto', height: 'auto', maxWidth: '480%', maxHeight: '270%', objectFit: 'contain' }
    },
    { 
      id: 3, 
      name: 'ClinAddis Mug', 
      price: '250 ETB', 
      desc: 'Ceramic coffee mug',
      image: mugImage,
      imageStyle: { width: 'auto', height: 'auto', maxWidth: '200%', maxHeight: '240%', objectFit: 'contain' }
    },
    { 
      id: 4, 
      name: 'Tote Bag', 
      price: '300 ETB', 
      desc: 'Reusable canvas bag',
      image: totebagImage,
      imageStyle: { width: 'auto', height: 'auto', maxWidth: '520%', maxHeight: '200%', objectFit: 'contain' }
    },
    { 
      id: 5, 
      name: 'Badge Cards', 
      price: '10/each ETB', 
      desc: 'Set of collectible badge cards for each speciality',
      image: badgecardsImage,
      imageStyle: { width: 'auto', height: 'auto', maxWidth: '460%', maxHeight: '240%', objectFit: 'contain' }
    },
  ];

  // CSS styles object
  const styles = {
    container: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '2rem'
    },
    productCard: {
      background: 'white',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    },
    imageContainer: {
      height: '180px',
      background: '#f5f5f5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      padding: '1rem'
    },
    productDetails: {
      padding: '1.5rem',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1
    },
    productName: {
      marginBottom: '0.5rem',
      fontSize: '1.1rem',
      color: '#2c4a7c'
    },
    productDescription: {
      color: '#666',
      marginBottom: '1rem',
      fontSize: '0.9rem',
      lineHeight: '1.5',
      flexGrow: 1
    },
    priceContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: 'auto'
    },
    price: {
      fontWeight: 'bold',
      color: '#2c4a7c',
      fontSize: '1.1rem'
    },
    buyButton: {
      padding: '0.5rem 1rem',
      fontSize: '0.9rem',
      fontWeight: '600',
      borderRadius: '4px',
      background: '#4a6fa5',
      border: 'none',
      color: 'white',
      cursor: 'pointer',
      transition: 'background 0.3s ease'
    },
    paymentSection: {
      background: '#f8f9fa'
    },
    paymentMethodsContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: '2rem',
      flexWrap: 'wrap'
    },
    paymentMethod: {
      textAlign: 'center',
      padding: '1rem',
      background: 'white',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      minWidth: '120px',
      transition: 'transform 0.3s ease'
    },
    paymentIcon: {
      fontSize: '2rem',
      marginBottom: '0.5rem',
      height: '2.5rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };

  return (
    <div className="merch">
      {/* Hero Section */}
      <section className="section hero-section merch-hero">
        <div className="container">
          <h1 className="text-center">ClinAddis Merchandise</h1>
          <p className="subtitle text-center">
            Wear your support for healthcare innovation
          </p>
        </div>
      </section>

      {/* Products */}
      <section className="section">
        <div className="container">
          <div style={styles.container}>
            {products.map(product => (
              <div 
                key={product.id} 
                style={styles.productCard}
                onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'}
                onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)'}
              >
                {/* Image container with background */}
                <div style={styles.imageContainer}>
                  <img 
                    src={product.image} 
                    alt={product.name}
                    style={product.imageStyle}
                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                    onError={(e) => {
                      // Fallback if image fails to load
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = '🛒';
                      e.target.parentElement.style.fontSize = '3rem';
                      e.target.parentElement.style.display = 'flex';
                      e.target.parentElement.style.alignItems = 'center';
                      e.target.parentElement.style.justifyContent = 'center';
                    }}
                  />
                </div>
                
                {/* Product details */}
                <div style={styles.productDetails}>
                  <h3 style={styles.productName}>
                    {product.name}
                  </h3>
                  <p style={styles.productDescription}>
                    {product.desc}
                  </p>
                  <div style={styles.priceContainer}>
                    <span style={styles.price}>
                      {product.price}
                    </span>
                    <button 
                      className="btn btn-primary" 
                      style={styles.buyButton}
                      onMouseEnter={(e) => e.target.style.background = '#2c4a7c'}
                      onMouseLeave={(e) => e.target.style.background = '#4a6fa5'}
                    >
                      Buy Now
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Payment Info */}
      <section className="section section-alt" style={styles.paymentSection}>
        <div className="container">
          <h2 className="text-center" style={{ marginBottom: '2rem' }}>Payment Options</h2>
          <p className="text-center" style={{ marginBottom: '2rem' }}>We accept Ethiopian payment methods:</p>
          <div style={styles.paymentMethodsContainer}>
            {['Telebirr 📱', 'CBE Birr 🏦'].map((method, index) => (
              <div 
                key={index} 
                style={styles.paymentMethod}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
              >
                <div style={styles.paymentIcon}>
                  {method.split(' ')[1]}
                </div>
                <div style={{ fontWeight: '500' }}>{method.split(' ')[0]}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Merch;